import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import {
  BillingErrorText,
  BillingRecoveryContext,
} from '@/features/billing/components/billing-recovery-context';
import { cn } from '@/lib/utils';
import { AlertCircle, RefreshCw } from 'lucide-react';
import { useContext } from 'react';

interface StateErrorProps {
  message?: string;
  onRetry?: () => void;
  className?: string;
}

export function StateError({
  message = 'Something went wrong. Please try again.',
  onRetry,
  className,
}: StateErrorProps) {
  const billingIssue = useContext(BillingRecoveryContext);
  if (billingIssue)
    return (
      <div className={cn('space-y-2', className)}>
        <p className="text-sm" role="alert">
          {message}
        </p>
        <BillingErrorText />
        {onRetry ? (
          <Button variant="outline" size="sm" onClick={onRetry}>
            Reload
          </Button>
        ) : null}
      </div>
    );
  return (
    <Alert variant="destructive" className={cn(className)}>
      <AlertCircle className="size-4" />
      <AlertDescription className="flex items-center justify-between gap-4">
        <span>{message}</span>
        {onRetry && (
          <Button variant="outline" size="sm" onClick={onRetry}>
            <RefreshCw className="mr-1 size-3" />
            Reload
          </Button>
        )}
      </AlertDescription>
    </Alert>
  );
}
